import * as jose from 'jose';
import { API_AUTH_TOKEN_DURATION } from '../../constants/timers';

export const generateApiToken = async (): Promise<string> => {
  const alg = 'ES256';
  try {
    return await new jose.SignJWT({})
      .setProtectedHeader({ alg })
      .setIssuer('EXP_UI')
      .setIssuedAt()
      .setExpirationTime(API_AUTH_TOKEN_DURATION)
      .sign(await jose.importPKCS8(process.env.REACT_APP_EXP_API_PRIVATE_KEY || '', alg));
  } catch (e) {
    console.error('Error occured while generating API token : ', e);
    return '';
  }
};
